/* unplugin-vue-components disabled */import { render } from "./NotificationItem.vue?vue&type=template&id=997dd484&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=997dd484&scoped=true&lang=scss"
import "./NotificationItem.vue?vue&type=style&index=1&id=997dd484&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997dd484"]])

export default __exports__